// App.js
import { useEffect, useState } from 'react';
import devtoolsDetect from 'devtools-detect';
import { createTheme, ThemeProvider, CssBaseline, GlobalStyles } from "@mui/material";
import { Route, Routes, useLocation } from 'react-router-dom';
import Home from "./pages/home/index";
import Privacy from './pages/privacy';
import TrackTrain from './pages/Tracking/index';
import { ToasterContainer } from './components/toaster/Toaster';
import { Analytics } from "@vercel/analytics/react";
import { initGA, trackPageView } from "./utils/analytics";

const theme = createTheme({
  typography: {
    fontFamily: "Poppins, Arial, sans-serif",
  },
});

function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    initGA();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

function App() {
  const [isDevToolsOpen, setIsDevToolsOpen] = useState(devtoolsDetect.isOpen);

  useEffect(() => {
    const checkDevTools = () => {
      if (devtoolsDetect.isOpen) {
        setIsDevToolsOpen(true);
        window.location.href = "https://www.google.com";
      }
    };

    const interval = setInterval(checkDevTools, 1000);

    const handleContextMenu = (e) => e.preventDefault();
    const handleKeyDown = (e) => {
      if (
        e.keyCode === 123 ||
        (e.ctrlKey && e.shiftKey && e.keyCode === 73) ||
        (e.ctrlKey && e.shiftKey && e.keyCode === 74) ||
        (e.ctrlKey && e.keyCode === 85)
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      clearInterval(interval);
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ToasterContainer />
      <Analytics />
      <GlobalStyles styles={{ body: { fontFamily: "Poppins, Arial, sans-serif" } }} />
      <RouteTracker />
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/track-train" element={<TrackTrain />} />
        </Routes>
      </div>
    </ThemeProvider>
  );
}

export default App;
